export default __webpack_public_path__ + "static/media/Mont-SemiBold.8979d71a.otf";